
import store from '@/store'
import JSEncrypt from 'jsencrypt';
import { base_url, onboarding } from '@/utilities/urls'

export const services = {
        token                       : () => `/wallet/token`, 
        perfil                      : () => `/wallet/perfil`, 
        cuenta                      : (id = '', path = '') => {
            if (id != '' && path == '') {
                return `/wallet/cuenta/${id}`
            }
            if (id != '' && path != '') {
                return `/wallet/cuenta/${id}/${path}`
            }
            return `/wallet/cuenta`
        }, 
        tarjetas_cliente_movs       : () => `/wallet/tarjetas-cliente-movs`, 
        importar_cuentas            : () => `/wallet/importar-cuentas`, 
        tarjetas_vinculadas         : () => `/wallet/tarjetas-vinculadas`,
        cliente_estadisticas        : () => `/wallet/cliente-estadisticas`, 
        tarjetas_cliente            : () => `/wallet/tarjetas-cliente`, 
        card_virtual                : () => `/wallet/card-virtual`,

        cambio_nip                  : () => `/wallet/cambio-nip`, 
        cambio_estatus              : () => `/wallet/cambio-estatus`, 
        generar_token               : () => `/wallet/generar-token`, 
        generate_cvv                : () => `/wallet/generate-cvv`, 
        show_nip                    : () => `/wallet/show-nip`, 

        estados_cuenta_sincrono     : () => `/wallet/estados-cuenta-sincrono`, 
        nubarium_token              : () => `/wallet/nubarium-token`, 
        transferir                  : () => `/wallet/transferir`, 
        cobranza                    : () => `/wallet/cobranza`, 
        consulta_banco              : () => `/wallet/consulta-banco`, 
        cuentas_guardadas           : () => `/wallet/cuentas-guardadas`, 
        movimientos_pendientes      : () => `/wallet/movimientos-pendientes`, 
        movimientos_masivos         : () => `/wallet/movimientos-masivos`, 
        aprobar_transferencia       : () => `/wallet/aprobar-transferencia`, 
        eliminar_transferencia      : () => `/wallet/eliminar-transferencia`, 
        // reporte_cuenta              : () => `/wallet/reporte-cuenta`, 
        generar_comprobante_lote    : () => `/wallet/generar-comprobante-lote`,
        envio_usuario_contrasena    : () => `/wallet/envio-usuario-contrasena`,
        validar_codigo_contrasena   : () => `/wallet/validar-codigo-contrasena`,
        cat_bancos                  : () => `/wallet/cat-bancos`,
        validar_stripe              : () => `/wallet/validar-stripe`,
        // validar_openpay             : () => `/wallet/validar-openpay`,
        cerrar_session              : () => `/wallet/cerrar-session`,
        cancel_stripe               : () => `/wallet/cancel-stripe`,
        iframe_stripe               : () => `/wallet/iframe-stripe`,
        // iframe_openpay              : () => `/wallet/iframe-openpay`,
        cancelar_transferencias     : () => `/wallet/cancelar-transferencias`,
        usuario_cuenta_guardada     : () => `/wallet/usuario-cuenta-guardada`,
        servicios                   : (id = '', path = '') => {
            if (id != '' && path == '') {
                return `/wallet/servicios/${id}`
            }
            if (id != '' && path != '') {
                return `/wallet/servicios/${id}/${path}`
            }
            return `/wallet/servicios`
        }, 
        change_password             : () => `/wallet/change-password`,
        permisos_cuenta             : () => `/wallet/permisos-cuenta`,
        cuentas_transacciones       : () => `/wallet/cuentas-transacciones`,
        doble_factor                : () => `/wallet/doble-factor`,
        codigo_verificacion         : () => `/wallet/codigo-verificacion`,
        codigo_validacion           : () => `/wallet/codigo-validacion`,
        asignar_tarjeta_inntec      : () => `/wallet/asignar-tarjeta-inntec`,
        valida_pa_se                : () => `/wallet/valida-pa-se`,
        valida_ps                   : () => `/wallet/valida-ps`,
        mdps                        : () => `/wallet/mdps`,
        recaptcha                   : () => `/wallet/recaptcha`,
        cuentas_ps                  : () => `/wallet/cuentas-ps`,
        totp_setup                  : () => '/wallet/totp-setup',
        pin                         : () => `/wallet/pin`,
        pin_estatus                 : () => `/wallet/pin-estatus`,
        pin_solicitud               : () => `/wallet/pin-solicitud`,
        preguntas_categoria         : (path = '', id_categoria = '', id_pregunta = '') => {
            if (id_categoria != '' && id_pregunta == '' && path != '') {
                return `/wallet/preguntas-categoria/${id_categoria}/${path}`
            }
            if (id_categoria != '' && id_pregunta != '' && path != '') {
                return `/wallet/preguntas-categoria/${id_categoria}/${path}/${id_pregunta}`
            }
            return `/wallet/preguntas-categoria`
        }, 
        comentarios                 : () => `/wallet/comentarios`,
        novedades                   : () => `/wallet/novedades`,
        mis_alcancias                   : (id = '', path = '') => {
            if (id != '' && path == '') {
                return `/wallet/mis-alcancias/${id}`
            }
            if (id != '' && path != '') {
                return `/wallet/mis-alcancias/${id}/${path}`
            }
            return `/wallet/mis-alcancias`
        }, 
        alcancia_cliente            : () => `/wallet/alcancia-cliente`,
        alcancia                    : (id) => `/wallet/alcancia/${id}/transaccion`,
        crear_alcancia              : () => `/wallet/crear-alcancia`,
        alcancia_deposito           : () => `/wallet/alcancia-deposito`,
        alcancia_retiro             : () => `/wallet/alcancia-retiro`,
        alcancia_nombre             : () => `/wallet/alcancia-nombre`,
        alcancia_monto              : () => `/wallet/alcancia-monto`,
        alcancia_cuenta_origen      : () => `/wallet/alcancia-cuenta-origen `,
        alcancia_periodicidad       : () => `/wallet/alcancia-periodicidad`,
        alcancia_beneficiarios      : () => `/wallet/alcancia-beneficiarios`,
        alcancia_categoria          : () => `/wallet/alcancia-categoria`,
        desvincular_tarjeta         : () => `/wallet/desvincular-tarjeta-inntec`,
        valida_seguridad            : () => `/wallet/valida-seguridad`,
        
        prestamo_productos          : ()   => `/prestamo/productos`,
        prestamo_calculadora        : ()   => `/prestamo/calculadora`,
        solicita_codigo             : ()   => `/prestamo/solicita-codigo`,
        valida_codigo               : ()   => `/prestamo/valida-codigo`,
        prestamo_alta               : ()   => `/prestamo/alta`,

        ps_categoria                : ()   => `/ps/categoria`,
        ps_productos                : ()   => `/ps/productos`,
        ps_pagar                    : ()   => `/ps/pagar`,

        pre_registro                : ()   => `/pre-registro`,
        codigo_producto             : ()   => `/codigo-producto`,
        preregistro_simple          : ()   => `/preregistro-simple`,
        valida_telefono             : (id) => `/prospecto/${id}/valida-telefono`,
        valida_correo               : (id) => `/prospecto/${id}/valida-correo`,
        valida_curp                 : (id) => `/prospecto/${id}/valida-curp`,
        registro                    : (id) => `/prospecto/${id}/registro`,
        documentacion               : (id) => `/prospecto/${id}/documentacion`,
        registro_final              : (id) => `/prospecto/${id}/registro-final`,
        catalogo_estados            : ()   => `/catalogo-estados`,
        reenvio_codigo_correo       : (id) => `/prospecto/${id}/reenvio-codigo-correo`,
        reenvio_codigo_telefono     : (id) => `/prospecto/${id}/reenvio-codigo-telefono`,
        actividad_economica         : ()   => `/actividad-economica`,
        catalogo_paises             : ()   => `/catalogo-paises`,
        nacionalidad                : ()   => `/nacionalidad`,
        cambiar_correo              : (id) => `/prospecto/${id}/cambiar-correo`,
        cambiar_telefono            : (id) => `/prospecto/${id}/cambiar-telefono`,
        registro_final_simple       : (id) => `/prospecto/${id}/registro-final-simple`,
        pk                          : ()   => `/wallet/pk`,
        encrypt                     : ()   => `/wallet/encrypt`,

}

export const fetchJS = async (
    {
        url,
        path = false,
        data_pk = null,
        method, 
        headers, 
        body, 
        mode,
        credentials,
        redirect,
        _token = ''
    }, auth = true, stringify = false) => {

        
    // si esta activa la bandera va a usar el fetch encriptado
    let sesion = false
    if (data_pk) {
        sesion = (('execute' in data_pk) && typeof data_pk.execute  == 'number') ? +data_pk.execute : false
    } else {
        sesion = (('user' in store.getters) && typeof store.getters.user  == 'object') ? +store.getters.user.execute : false
    }

    if (sesion) {
        const response = await secureFetchJs({
            path : url,
            payload : body,
            method : method,
            data_pk : data_pk,
            auth : auth,
            _token : _token
        })

        if (!response) {
            return {
                'status' : 503,
                'data' : {
                    message : 'Service Unavailable',
                    error : true
                }
            }
        }
        return response

    }
    
    const dom = !path ? base_url : onboarding
    const object = {};

    (method) && (object.method = method);
    // (headers) && (object.headers = headers);
    (body) && (object.body = body);
    (mode) && (object.mode = mode);
    (credentials) && (object.credentials = credentials);
    (redirect) && (object.redirect = redirect);
    
    let token = ''
    if (auth) {        
        token = _token === '' ? store.getters.user.token : _token
    }

    const _headers = headers ?? { 
        "Accept" : "application/json",
        "Content-Type": "application/x-www-form-urlencoded",
    }

    auth && ( _headers['Authorization'] = `Bearer ${token}`)
    object.headers = _headers

    if (body && !stringify) {
        const urlencoded = new URLSearchParams();
        Object.keys(body).forEach(key =>{
            urlencoded.append(key, body[key]);
        });

        object.body = urlencoded
    }

    (body && stringify) && (object.body = body)
    
    const response = await fetch(dom + url, object);
    const jsonResponse = await response.json();

    const isAuthenticated = store.getters.isAuthenticated;

    if (isAuthenticated && response.status == 401) {
        store.dispatch('logout');
        document.location.href = "/";
    }

    return {
        'status' : response.status,
        'data' : jsonResponse 
    }

}

const secureFetchJs = async ({path, payload, method, data_pk, auth, _token}) => {
    // si es verbo GET entonces solo descifra la repsuesta, no el body pues get no tiene body
    if (method == 'GET') {
        return secureFetchJsGET({
            path : path,
            data_pk: data_pk,
            auth : auth,
            _token : _token
        });
    }
    const url = base_url + path;
    const te = new TextEncoder();
    const td = new TextDecoder();
    // --- Generar session key (64 bytes → 32 enc + 32 mac) ---
    const sessionKey = crypto.getRandomValues(new Uint8Array(64));
    const encKey = sessionKey.slice(0, 32);
    const macKey = sessionKey.slice(32);

    // --- Serializar en base64 y cifrar con RSA ---
    const keyB64 = btoa(String.fromCharCode.apply(null, sessionKey));
    const jsEnc = new JSEncrypt();
    const pemKey = data_pk ? data_pk.pem : store.getters.user.pem
    jsEnc.setPublicKey(pemKey);
    const ekey = jsEnc.encrypt(keyB64);
    if (!ekey) throw new Error("No se pudo cifrar la session key");

    // --- AES-CBC ---
    const iv = crypto.getRandomValues(new Uint8Array(16));
    const envelope = { ts: new Date().toISOString(), payload };
    const pt = te.encode(JSON.stringify(envelope));
    const aesKey = await crypto.subtle.importKey('raw', encKey, { name: 'AES-CBC' }, false, ['encrypt']);
    const ct = new Uint8Array(await crypto.subtle.encrypt({ name: 'AES-CBC', iv }, aesKey, pt));

    // --- HMAC ---
    const macKeyImp = await crypto.subtle.importKey('raw', macKey, { name: 'HMAC', hash: 'SHA-256' }, false, ['sign']);
    const hmacBuf = await crypto.subtle.sign('HMAC', macKeyImp, concatCipher(iv, ct));
    const hmac = new Uint8Array(hmacBuf);

    // Logs de petición
    //   console.log(" REQ IV hex:", Array.from(iv).map(x => x.toString(16).padStart(2, '0')).join(''));
    //   console.log(" REQ CT len:", ct.length);
    //   console.log(" REQ HMAC hex:", Array.from(hmac).map(x => x.toString(16).padStart(2, '0')).join(''));
    const kid = data_pk ? data_pk.kid : store.getters.user.kid
    const _headers = {
        'Content-Type': 'application/octet-stream',
        'X-KID': kid,
        //'Authorization': `Bearer ${store.getters.user.token}`,
        'X-IV': b64uCipher(iv),
        'X-HMAC': b64uCipher(hmac),
        'X-EKey': ekey
    }
    if (auth) {        
        const tokenAuth = _token === '' ? store.getters.user.token : _token
        _headers['Authorization'] = `Bearer ${tokenAuth}`
    }
    
    // --- Enviar al backend ---
    const res = await fetch(url, {
        method: method,
        headers: _headers,
        body: b64uCipher(ct),
    });

    const isAuthenticated = store.getters.isAuthenticated;

    if (isAuthenticated && res.status == 401) {
        store.dispatch('logout');
        document.location.href = "/";
    }

    const responseText = await res.text();
    if (isJsonString(responseText)) {
        return false
    }

    // --- Respuesta ---
    const iv2 = deb64uCipher(res.headers.get('X-IV'));
    const hmac2 = deb64uCipher(res.headers.get('X-HMAC'));
    const ct2 =  deb64uCipher(responseText);

    // Logs de respuesta
    //   console.log("RESP IV hex:", Array.from(iv2).map(x => x.toString(16).padStart(2, '0')).join(''));
    //   console.log("RESP CT len:", ct2.length);
    //   console.log("RESP HMAC hex:", Array.from(hmac2).map(x => x.toString(16).padStart(2, '0')).join(''));

    // --- Verificar HMAC ---
    const macKeyImpRx = await crypto.subtle.importKey('raw', macKey, { name: 'HMAC', hash: 'SHA-256' }, false, ['verify']);
    const ok = await crypto.subtle.verify('HMAC', macKeyImpRx, hmac2, concatCipher(iv2, ct2));
    if (!ok) throw new Error("Bad HMAC en respuesta");

    // --- Descifrar ---
    const aesKeyRx = await crypto.subtle.importKey('raw', encKey, { name: 'AES-CBC' }, false, ['decrypt']);
    const plain = await crypto.subtle.decrypt({ name: 'AES-CBC', iv: iv2 }, aesKeyRx, ct2);
    // console.log(JSON.parse(td.decode(plain)).payload || {}, url)
    if (!res.ok) {
        const t = await res.text().catch(() => '');
        // throw new Error(`HTTP ${res.status}: ${t}`);
        return {
            'status' : res.status,
            'data' : JSON.parse(td.decode(plain)).payload || {}, url
        }
    }
    return {
        'status' : res.status,
        'data' : JSON.parse(td.decode(plain)).payload
    }

}
const secureFetchJsGET = async ({ path, data_pk, auth, _token }) => {
    const url = base_url + path;
    const te = new TextEncoder();
    const td = new TextDecoder();
    // --- Generar session key (64 bytes → 32 enc + 32 mac) ---
    const sessionKey = crypto.getRandomValues(new Uint8Array(64));
    const encKey = sessionKey.slice(0, 32);
    const macKey = sessionKey.slice(32);

    // --- Serializar en base64 y cifrar con RSA ---
    const keyB64 = btoa(String.fromCharCode.apply(null, sessionKey));
    const jsEnc = new JSEncrypt();

    const pemKey = data_pk ? data_pk.pem : store.getters.user.pem

    jsEnc.setPublicKey(pemKey);
    const ekey = jsEnc.encrypt(keyB64);
    if (!ekey) throw new Error("No se pudo cifrar la session key");

    // --- Como es GET, el payload es vacío pero mandamos timestamp ---
    const iv = crypto.getRandomValues(new Uint8Array(16));
    const envelope = { ts: new Date().toISOString(), payload: null };
    const pt = te.encode(JSON.stringify(envelope));
    const aesKey = await crypto.subtle.importKey('raw', encKey, { name: 'AES-CBC' }, false, ['encrypt']);
    const ct = new Uint8Array(await crypto.subtle.encrypt({ name: 'AES-CBC', iv }, aesKey, pt));

    // --- HMAC ---
    const macKeyImp = await crypto.subtle.importKey('raw', macKey, { name: 'HMAC', hash: 'SHA-256' }, false, ['sign']);
    const hmacBuf = await crypto.subtle.sign('HMAC', macKeyImp, concatCipher(iv, ct));
    const hmac = new Uint8Array(hmacBuf);

    const kid = data_pk ? data_pk.kid : store.getters.user.kid

    const headers = {
        'Content-Type': 'application/octet-stream',
        'X-KID': kid,
        //'Authorization': `Bearer ${store.getters.user.token}`,
        'X-IV': b64uCipher(iv),
        'X-HMAC': b64uCipher(hmac),
        'X-EKey': ekey
    }
    if (auth) {        
        const tokenAuth = _token === '' ? store.getters.user.token : _token
        headers['Authorization'] = `Bearer ${tokenAuth}`
    }

    // --- Enviar al backend (sin body porque es GET) ---
    const res = await fetch(url, {
        method: 'GET',
        headers: headers,
    });

    const isAuthenticated = store.getters.isAuthenticated;

    if (isAuthenticated && res.status == 401) {
        store.dispatch('logout');
        document.location.href = "/";
    }

    const responseText = await res.text();
    if (isJsonString(responseText)) {
        return false
    }

    // --- Respuesta ---
    const iv2 = deb64uCipher(res.headers.get('X-IV'));
    const hmac2 = deb64uCipher(res.headers.get('X-HMAC'));
    const ct2 = deb64uCipher(responseText);

    // --- Verificar HMAC ---
    const macKeyImpRx = await crypto.subtle.importKey('raw', macKey, { name: 'HMAC', hash: 'SHA-256' }, false, ['verify']);
    const ok = await crypto.subtle.verify('HMAC', macKeyImpRx, hmac2, concatCipher(iv2, ct2));
    if (!ok) throw new Error("Bad HMAC en respuesta");

    // --- Descifrar ---
    const aesKeyRx = await crypto.subtle.importKey('raw', encKey, { name: 'AES-CBC' }, false, ['decrypt']);
    const plain = await crypto.subtle.decrypt({ name: 'AES-CBC', iv: iv2 }, aesKeyRx, ct2);
    // console.log(JSON.parse(td.decode(plain)).payload || {}, url)
    if (!res.ok) {
        return {
            status: res.status,
            data: JSON.parse(td.decode(plain)).payload || {}, url
        };
    }
    // console.log(JSON.parse(td.decode(plain)).payload || {}, url)
    return {
        status: res.status,
        data: JSON.parse(td.decode(plain)).payload
    };
};


const isJsonString = (str) => {
    try {
        const json = JSON.parse(str.trim())
        if (typeof json == 'object') {
            return true;
        }
        return false;
    } catch (e) {
        return false;
    }
}
function b64uCipher(bytes) {
    let s = '';
    for (const b of bytes) s += String.fromCharCode(b);
    return btoa(s).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
}
function deb64uCipher(s) {
    if (!s) return new Uint8Array(); // devuelve array vacío si viene null/undefined
    const pad = s.length % 4 ? '='.repeat(4 - (s.length % 4)) : '';
    const bin = atob(s.replace(/-/g, '+').replace(/_/g, '/') + pad);
    return Uint8Array.from(bin, (c) => c.charCodeAt(0));
}
function concatCipher(a, b) {
    const out = new Uint8Array(a.length + b.length);
    out.set(a, 0);
    out.set(b, a.length);
    return out;
}